var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4934 17.3334V12.0001C29.4934 5.33341 26.8268 2.66675 20.1601 2.66675H12.1601C5.49345 2.66675 2.82678 5.33341 2.82678 12.0001V20.0001C2.82678 26.6667 5.49345 29.3334 12.1601 29.3334H17.4934",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1602 10.4998C18.7602 14.4731 14.2402 18.2333 9.16016 19.5",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9067 10H22.8134V13.8933",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1335 21.0932L26.5068 21.8532C26.6935 22.2265 27.1601 22.5732 27.5734 22.6532L28.0801 22.7332C29.6001 22.9865 29.9601 24.1065 28.8668 25.2132L28.4001 25.6798C28.0934 25.9998 27.9201 26.6132 28.0135 27.0398L28.0801 27.3198C28.4934 29.1598 27.5201 29.8665 25.9201 28.9065L25.5734 28.7065C25.1601 28.4665 24.4934 28.4665 24.0801 28.7065L23.7334 28.9065C22.1201 29.8798 21.1468 29.1598 21.5734 27.3198L21.6401 27.0398C21.7334 26.6132 21.5601 25.9998 21.2535 25.6798L20.7868 25.2132C19.6934 24.1065 20.0534 22.9865 21.5734 22.7332L22.0801 22.6532C22.4801 22.5865 22.9601 22.2265 23.1468 21.8532L23.5201 21.0932C24.2401 19.6398 25.4135 19.6398 26.1335 21.0932Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteChart);
export default __webpack_public_path__ + "static/media/favorite-chart.be70631e.svg";
export { ForwardRef as ReactComponent };